const state = {
  collection: {},
  sort: {
    value: "MANUAL",
    reverse: false,
  },
  reverse: false,
  isFiltersOpen: false,
  loading: true,
  maximiumPriceRange: {
    min: null,
    max: null,
  },
  filters: [],
  sortOptions: [
    {
      value: "BEST_SELLING",
      label: "Best Sellers",
    },
    {
      value: "CREATED",
      label: "Newest",
    },
    {
      value: "PRICE_DESC",
      label: "Price: High-Low",
    },
    {
      value: "PRICE_ASC",
      label: "Price: Low-High",
    },
  ],
  imageSequenceType: "curated",
};

const getters = {
  types: (state) => {
    const productTypes = state.collection.products?.filters?.find(
      (filter) => filter.id === "filter.p.product_type"
    );

    return productTypes?.values;
  },
  products: (state) => {
    const productEdges = state.collection.products?.edges;
    const products = productEdges?.map((edge) => edge.node);

    return products || [];
  },
  visibleProductCount: (state, getters) => {
    const products = getters.products;
    return products ? products.length : 0;
  },
  productCount: (state) => {
    const availability = state.collection.products?.filters?.find(
      (filter) => filter.id === "filter.p.product_type"
    );

    const values = availability?.values;

    const count = values
      ? values.reduce((acc, value) => acc + value.count, 0)
      : 0;

    return count;
  },
  activeSort: (state) => {
    let value;
    if (state.sort.value === "PRICE") {
      value = state.sort.value + (state.sort.reverse ? "_DESC" : "_ASC");
    } else {
      value = state.sort.value;
    }

    return {
      value,
      reverse: state.sort.reverse,
    };
  },
  availableFilters: (state) => {
    return state.collection?.products?.filters || {};
  },
};

const mutations = {
  setIsFiltersOpenState(state, value) {
    state.isFiltersOpen = value;
  },
  setPriceRangeState(state, value) {
    state.maximiumPriceRange = value;
  },
  setCollection(state, value) {
    state.collection = value;
  },
  setSort(state, value) {
    state.sort = value;
  },
  setLoading(state, value) {
    state.loading = value;
  },
  setFilters(state, value) {
    state.filters = value;
  },
  setImageSequenceType(state, value) {
    state.imageSequenceType = value;
  },
};

const actions = {
  setIsFiltersOpen({ commit }, value) {
    commit("setIsFiltersOpenState", value);
  },
  setPriceRange({ commit }, value) {
    commit("setPriceRangeState", value);
  },
  setCollection({ commit }, value) {
    commit("setCollection", value);
  },
  setSort({ commit }, sort) {
    commit("setSort", sort);
  },
  setLoading({ commit }, value) {
    commit("setLoading", value);
  },
  setFilters({ commit }, value) {
    commit("setFilters", value);
  },
  setImageSequenceType({ commit }, value) {
    commit("setImageSequenceType", value);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
